import {createApp, nextTick} from "vue";

const axios = require('axios');
import InputText from "./vueComponents/InputText.vue";
import Modal from "./vueComponents/Modal.vue";
import InputSelect from "./vueComponents/InputSelect.vue";
import InputCustomRadio from "./vueComponents/InputCustomRadio.vue";
import InputRange from "./vueComponents/InputRange.vue";
import InputRangeBetween from "./vueComponents/InputRangeBetween.vue";
import { forEach } from "lodash";

export default {
    name: "productFinder",
    _el: null,
    _maps: null,

    init() {
        const elements = document.querySelectorAll(".js_product-finder");

        if (elements) {
            elements.forEach((el) => this.run(el));
        }
    },

    run(vueElement) {
        const vueElementId = vueElement.id;

        const app = createApp({

            data() {
                return  {
                    loading: true,
                    products: [],
                    filteredProducts: [],
                    lastAddedFilter : '',
                    activeFilters: [],
                    searchUrl: '',
                    action: null,
                    resource: '',
                    slug: '',
                    host: '',
                    step: 0,
                    steps: 0,
                    filters: {},
                    forcedSearch: {},
                    compare: {
                        "===": function (a, b) {
                            return a === b;
                        },
                        "<=": function (a, b) {
                            return a <= b;
                        },
                        "<= >=": function (a, arr) {
                            return a >= arr[0] && a <= arr[1];
                        },
                    },
                    searchParams: {
                        transmission : 'tr',
                        certificates : 'wt',
                        superstructureTypes : 'pt',
                        salesForms : 'sf',
                        wheelDrives : 'wd',
                        brand : 'br',
                    }
                }
            },

            delimiters: ["@{", "}"],

            computed: {
                isLastStep(){
                    return this.step >= this.steps - 1;
                },

                buttonText() {
                    return this.step === this.steps - 1
                        ? "Vis resultat"
                        : "Gå videre";
                },

                gtmClass() {
                    return this.step === this.steps - 1
                        ? "gtm_product-finder"
                        : "";
                },

                minPrice() {
                    return this.getMinValue('price');
                },

                maxPrice() {
                    return this.getMaxValue('price');
                },

                minBeds() {
                    return this.getMinValue('noOfBeds');
                },

                maxBeds() {
                    return this.getMaxValue('noOfBeds');
                },

                queryString() {
                    let queryString = '';
                    for (let filter of this.activeFilters) {
                        if (!filter.key || ! filter.value) {
                            continue;
                        }

                        console.log('filter', filter);

                        let filterKey = filter.key;

                          if(typeof filter.value === 'object' && filter.value.length === 2) {
                            queryString += this.buildQueryParameter(`${filterKey}From`, filter.value[0]);
                            queryString += this.buildQueryParameter(`${filterKey}To`, filter.value[1]);
                        } else if ( typeof filter.value === 'string') {
                              queryString += this.buildQueryParameter(this.searchParams[filterKey] ?? null, filter.value);
                      }

                    }

                    console.log('queryString', queryString);

                    return queryString;
                },
            },
            watch: {
                forcedSearch() {
                    if (this.forcedSearch.length > 0) {
                        this.forcedSearch.forEach((filter) => {
                            this.addFilter(filter.filter, filter.value, filter.operator);
                        });
                    }
                },
            },

            methods: {
                buildQueryParameter(name, value) {
                    return  (name && value ) ? `${name}=${value}&` : '';
                },

                getMaxValue(attr) {
                    const items = this.products;
                    let maxValue = 0;
                    if (items.length > 0) {
                        const item = this.products.reduce((min, current) => current[attr] > min[attr] ? current : min);
                        maxValue = item[attr];
                    }

                    return maxValue;
                },

                getMinValue(attr) {
                    const items = this.products;

                    let minValue = 0;
                    if (items.length > 0) {
                        const item = this.products.reduce((min, current) => current[attr] < min[attr] ? current : min);
                        minValue = item[attr];
                    }

                    return minValue;
                },

                fetchProducts() {
                    this.apiUrl = this.host + "actions/ck/" + this.resource;

                    return axios({
                        method: "get",
                        url: this.apiUrl,
                    }).then(this.fetchProducts__callback);
                },

                fetchProducts__callback(response) {
                    // console.log('fetchProducts__callback');
                    // console.log(response.data);
                    if (typeof response.data === 'object') {
                        this.products = response.data;
                        this.filterProducts();
                        this.loading = false;
                    } else {
                        console.warn('👹 no product data');
                    }
                },

                calcFilterQuantity() {
                    // console.log('calcFilterQuantity()');
                    this.resetQuantity();
                    // console.log('this.filters');
                    // console.log(this.filters);
                    Object.values(this.filters).forEach((filter) => {
                        if (Array.isArray(filter)) {
                            this.getTotalQuantity(filter);
                        } else {
                            this.getMinMaxQuantity("noOfBeds");
                            this.getMinMaxQuantity("price");
                        }
                    });
                },

                resetQuantity() {
                    Object.keys(this.filters).forEach((key) => {
                        if (Array.isArray(this.filters[key])) {
                            this.filters[key].forEach((el) => el.quantity = 0);
                        }
                    });
                },

                getTotalQuantity(filter) {
                    filter.forEach((el) => {
                        this.getFilteredProducts().forEach((p) => {
                            if (el.value === p.transmission) {
                                el.quantity += 1;
                            }

                            if (el.value === p.certificate) {
                                el.quantity += 1;
                            }

                            if (el.value === p.superstructureTypes) {
                                el.quantity += 1;
                            }

                            if (el.value === p.salesForms) {
                                el.quantity += 1;
                            }

                            if (el.value === p.wheelDrives) {
                                el.quantity += 1;
                            }

                            if (el.value === p.retailer) {
                                el.quantity += 1;
                            }

                            if (el.value === "all") {
                                el.quantity = this.getFilteredProducts().length;
                            }
                        });
                    });
                },

                getMinMaxQuantity(filterName) {
                    const allValues = [];

                    this.getFilteredProducts().forEach((p) => {
                        if (p[filterName]) {
                            allValues.push(p[filterName]);
                            this.filters[filterName].max = Math.max(
                                ...allValues
                            );
                            this.filters[filterName].min = Math.min(
                                ...allValues
                            );
                            this.filters[filterName].start = Math.round(
                                (this.filters[filterName].max + this.filters[filterName].min) / 2
                            );
                        }
                    });
                },

                serializeProducts() {
                    this.products.forEach((p, i) => {
                        //@TODO leasing, til leie
                        p.certificate = p.wt > 3500 ? "Klasse C1" : "Klasse B";
                        p.transmission = p.tr.value;
                        p.noOfBeds = parseInt(p.b);
                        p.price = parseInt(p.p);
                        p.superstructureTypes = p.pt;
                        p.salesForms = p.sf;
                        p.wheelDrives = p.wd.value;
                        p.retailer = p.rl;
                        p.brand = p.br;
                    });

                    return this.products;
                },

                buildSearchUrl() {
                    this.searchUrl = this.host + this.slug + "?" + this.queryString;
                },

                addFilter(filterName, filterValue, operator) {
                    //console.log(`addFilter(${filterName} | ${filterValue} | ${operator})`);
                    this.lastAddedFilter = filterName;

                    // ignore if filterName is missing
                    if (typeof filterName === 'undefined') {
                        return false;
                    }
                    // remove existing setting from active filters
                    this.removeFilterFromActiveFilters(filterName);
                    // ignore if value is missing (i. e. when selecting "all")
                    if (filterValue === null) {
                        return false;
                    }
                    // make new filter object
                    const filter = {
                        key : filterName,
                        value : filterValue,
                        operator: operator,
                    };
                    // push filter to active filters
                    this.activeFilters.push(filter)
                    this.buildSearchUrl();
                },

                removeFilterFromActiveFilters(filterName) {
                     if (filterName.length) {
                      this.activeFilters = this.activeFilters.filter((f) => f.key !== filterName);
                    }
                },

                getCheckedValue(filterName, filterValue) {
                    const result = this.activeFilters.filter((f) => f.key === filterName);

                    return (result.length === 1) ? result[0].value : null;
                },

                getFilteredProducts() {
                    return this.filteredProducts ?? [];
                },

                resetFilteredProducts() {
                    this.filteredProducts = this.serializeProducts();
                },

                filterProducts() {
                    // console.log('🤯 filterProducts()');
                    this.resetFilteredProducts();

                    for (const filter of this.activeFilters) {
                        if (typeof filter.key !== 'undefined') {
                            this.filteredProducts = this.getFilteredProducts().filter(
                                (product) => {
                                    // calling defined callback method and sending product[attr] + filter.value
                                    return this.compare[filter.operator](product[filter.key], filter.value);
                                }
                            );
                        }
                    }

                    this.calcFilterQuantity();
                },

                isActive(stepIndex) {
                    return this.step === stepIndex ? "active" : "";
                },

                nextStep(e) {
                    if(this.isLastStep){
                        window.location.href = this.searchUrl;
                    } else {
                        e.preventDefault();
                        setTimeout(() => {
                            this.$refs.nextStepButton.focus();
                        }, 200);
                    }

                    this.step += 1;
                    this.filterProducts();
                },

                prevStep() {
                    this.step -= 1;
                    this.removeFilterFromActiveFilters(this.lastAddedFilter);
                    this.filterProducts();
                },

                getCountSteps() {
                    this.steps = document.querySelectorAll(
                        `#${vueElement.id} .product-finder-step`
                    ).length;
                },

                getSlug() {
                    this.resource = document.getElementById(
                        vueElement.id
                    ).dataset.resource;

                    if (this.resource === "caravans") {
                        this.slug = "bobiler";
                    } else if (this.resource === "new-caravans") {
                        this.slug = "nye-bobiler";
                    } else if (this.resource === "caravan-trailers") {
                        this.slug = "campingvogner";
                    } else if (this.resource === "new-caravan-trailers") {
                        this.slug = "nye-campingvogner";
                    } else if (this.resource === "cars") {
                        this.slug = "biler";
                    }
                },
            },

            created() {
                this.host =document.querySelector('[name="site_root"]').content;
                this.filters =  JSON.parse(document.getElementById(vueElement.id).dataset.filters);
                this.forcedSearch =  JSON.parse(document.getElementById(vueElement.id).dataset.forcedSearch);
                this.getSlug();
                this.fetchProducts();
            },
            mounted() {
                this.getCountSteps();
            }

        });

        app.component('input-text', InputText);
        app.component('input-select', InputSelect);
        app.component('input-custom-radio', InputCustomRadio);
        app.component('input-range', InputRange);
        app.component('input-range-between', InputRangeBetween);
        app.component('modal', Modal);
        app.mount('#'+vueElementId);
    },
};
